import { ROUTES } from 'config/routes'
import { berthApiClient } from 'repositories/BerthApi/berthApiClient'
import { signOutEndpoint } from 'repositories/BerthApi/signOut/endpoint'

import loginStorage from './loginStorage'
import { clearPostLoginRedirect } from './postLoginRedirect'

export const logout = async (): Promise<void> => {
  try {
    await berthApiClient.delete(signOutEndpoint())
  } catch {
    // API失敗してもローカルはクリアする
  }
  loginStorage.clearAuthData()
  // ログアウト後の再ログインで直前の画面に戻されないよう戻り先を破棄する
  clearPostLoginRedirect()
  window.location.href = ROUTES.login
}
